import { boundNumberToRange } from "@/pages/Tagging/utils/boundNumberToRange";

/**
 * Copied from V1 Tagging/components/shared/VisualizationContainer/svg/
 * StrikeZoneVisualization.tsx so the design can diverge. Props-only: no Redux.
 */

type StrikeZoneProps = {
  ballX?: number;
  ballY?: number;
  isStrike?: boolean;
  perspective?: "pitcher" | "catcher";
  isSoftball?: boolean;
  className?: string;
  /** Test hook: literal id from the call site */
  "data-testid"?: string;
};

const STRIKE_COLOR = "#5BD07A";
const NEUTRAL_COLOR = "#6B7280"; // gray-500
const ZONE_WIDTH = 381;
const ZONE_HEIGHT = 477;

export const StrikeZone = ({
  ballX,
  ballY,
  isStrike,
  perspective = "pitcher",
  isSoftball = false,
  className,
  "data-testid": testId,
}: StrikeZoneProps) => {
  // Softball vs baseball radius determined by ball size
  const ballRadius = isSoftball ? "41" : "31.5";
  const hasBall = ballX != null && ballY != null;
  const zoneColor = hasBall && isStrike ? STRIKE_COLOR : NEUTRAL_COLOR;

  return (
    <svg
      data-testid={testId}
      data-has-ball={hasBall}
      data-strike={isStrike}
      className={className}
      viewBox="-50 -62 481 765"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M132.441 0.916504V472.133M264.671 0.916504V472.133M379.642 311.142H12.9209M379.642 157.581H12.9209"
        stroke={zoneColor}
        strokeOpacity="0.5"
        strokeMiterlimit="3.99933"
      />

      <rect
        x="15.4209"
        y="3.4165"
        width="362.824"
        height="466.217"
        stroke={zoneColor}
        strokeWidth="5"
        rx="15"
      />

      {hasBall && (
        <circle
          // boundNumberToRange keeps the ball svg reasonably close to the zone
          // in the event that it's WAY far away, for the sake of looking pretty
          // ballX/ballY are percentages of the 381x477 zone box
          cx={(boundNumberToRange(-10, ballX, 110) / 100) * ZONE_WIDTH}
          cy={(boundNumberToRange(-8, ballY, 130) / 100) * ZONE_HEIGHT}
          r={ballRadius}
          fill={isStrike ? STRIKE_COLOR : NEUTRAL_COLOR}
        />
      )}

      {/* Home plate */}
      {perspective === "catcher" ? (
        <path
          d="M381.508 622.419L13.9757 622.416L13.976 659.3L196.425 698.161L381.508 659.3V522.419Z"
          fill={NEUTRAL_COLOR}
          fillOpacity="0.4"
        />
      ) : (
        <path
          d="M381.083 658.055L13.550859 658.058L13.551244 621.174L196 582.313L381.083 621.174V571.055Z"
          fill={NEUTRAL_COLOR}
          fillOpacity="0.4"
        />
      )}
    </svg>
  );
};
